import YandexBrowserAd from './YandexBrowserAd';
function leaderAvatar(leader) {
  if (leader.avatarUrl) return m('span.dc-avatar', m('img', {
    src: leader.avatarUrl,
    alt: ''
  }));
  return m('span.dc-avatar', leader.username.slice(0, 1).toLocaleUpperCase('ru-RU'));
}
export default function Rail(_ref) {
  let {
    leaders,
    period,
    onPeriodChange,
    stats
  } = _ref;
  const currentLeaders = leaders[period] || [];
  return m('aside.dc-sidebar.dc-sidebar--right', [m('section.dc-card.dc-widget', [m('div.dc-widget__head', [m('h3.dc-widget__title', 'Топ участников'), m('div.dc-seg', [m('button', {
    className: period === 'week' ? 'is-on' : '',
    onclick: () => onPeriodChange('week')
  }, 'Неделя'), m('button', {
    className: period === 'month' ? 'is-on' : '',
    onclick: () => onPeriodChange('month')
  }, 'Месяц')])]), m('div.dc-contrib', currentLeaders.map(leader => m('a.dc-contrib__row', {
    href: leader.url,
    key: leader.username
  }, [m(`span.dc-rank.dc-rank--${leader.rank}`, leader.rank), leaderAvatar(leader), m('div.dc-contrib__info', [m('b', leader.username), m('small', 'Участник сообщества')]), m('span.dc-contrib__points', leader.score)]))), m('a.dc-link.dc-link--sm.dc-widget__more', {
    href: '/users'
  }, 'Весь рейтинг →')]), m('section.dc-card.dc-widget', [m('h3.dc-widget__title', 'Сейчас онлайн'), m('div.dc-online', [m('div.dc-online__num', [m('b', stats.online || 0), m('span.dc-dot.dc-dot--live')]), m('p', 'Активные участники за последние пять минут')])]), m('section.dc-card.dc-widget', [m('h3.dc-widget__title', 'Достижения'), m('div.dc-ach', [['#7c3aed', 'Эксперт', '100 принятых ответов'], ['#2563eb', 'Наставник', '500 полезных ответов'], ['#0891b2', 'Автор', '25 опубликованных статей'], ['#10b981', 'Помощник', '1000 реакций сообщества']].map(_ref2 => {
    let [color, name, tip] = _ref2;
    return m('div.dc-ach__item.dc-tip', {
      'data-tip': tip,
      tabindex: 0
    }, [m('span.dc-ach__icon', {
      style: `--c:${color}`
    }, '✦'), name]);
  }))]), YandexBrowserAd()]);
}
flarum.reg.add('devconnect-portal', 'forum/components/Rail', Rail);